import React from "react";
import "./productList.css";
import Product from "./products/product";
import { products } from "../../data";

function ProductList() {
  return (
    <div className="pl h-full" id="work">
      <div className="pl-items">
        <div className="pl-title">
          <h1>
            <span>02.</span> Projects
          </h1>
        </div>

        <div className="pl-list">
          {products.map((item) => (
            <Product
              key={item.id}
              title={item.title}
              link={item.link}
              desc={item.desc}
              site={item.site}
              tech1={item.tech1}
              img={item.img}
              embed={item.site}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProductList;
